import { Directive } from '@angular/core';

import { injectTellentAssistantExternalLinkOpener } from './link-opener.token';

/**
 * Routes every external link inside the assistant through the host-provided opener
 * from a single delegated listener, so native hosts present them in an in-app
 * browser. Delegation rather than per-anchor directives because markdown answers
 * render their anchors through `[innerHTML]`, where no directive can bind, and
 * because opt-in wiring silently misses any anchor added later.
 *
 * In-app links keep their own `TellentAssistantLinkDirective` on the anchor: it
 * runs first, so anything it handled arrives here already defaultPrevented.
 */
@Directive({
  selector: '[tellentAssistantExternalLinks]',
  host: {
    '(click)': 'onClick($event)',
  },
})
export class TellentAssistantExternalLinksDirective {
  private readonly opener = injectTellentAssistantExternalLinkOpener({ optional: true });

  protected onClick(event: MouseEvent): void {
    // Modified and non-primary clicks mean "open in a new tab" on web — leave them.
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const href = (<Element | null>event.target)?.closest('a[href]')?.getAttribute('href');
    if (href && this.opener?.(href)) event.preventDefault();
  }
}
